import React from 'react';
import { View, Image, TouchableOpacity, StyleSheet, Text } from 'react-native';
import * as ImagePicker from 'expo-image-picker';
import { MaterialIcons } from '@expo/vector-icons';
import { getProfileImageUrl } from '../../utils/imageUtils';

const ProfilePhoto = ({ image, onImageSelect, error }) => {
  const handleImagePick = async () => {
    try {
      const permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();

      if (!permissionResult.granted) {
        alert('Permission to access camera roll is required!');
        return;
      }

      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [1, 1],
        quality: 0.8,
      });

      if (!result.canceled && result.assets[0]) {
        const asset = result.assets[0];
        onImageSelect({
          uri: asset.uri,
          type: 'image/jpeg',
          name: 'profile.jpg'
        });
      }
    } catch (error) {
      console.error('Error picking image:', error);
      alert('Error selecting image. Please try again.');
    }
  };

  // Log image information for debugging
  React.useEffect(() => {
    if (image) {
      console.log('ProfilePhoto - Image info:', {
        type: typeof image,
        isObject: typeof image === 'object',
        uri: typeof image === 'object' ? 'From object' : 'From string',
        hasUri: typeof image === 'object' ? !!image.uri : 'N/A'
      });
    }
  }, [image]);

  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={handleImagePick} style={styles.photoContainer}>
        {image ? (
          <Image
            source={{ uri: getProfileImageUrl(typeof image === 'object' ? image.uri : image) }}
            style={styles.photo}
            onError={(e) => console.log('Image loading info (likely path sync):', e.nativeEvent.error)}
          />
        ) : (
          <View style={styles.placeholder}>
            <MaterialIcons name="add-a-photo" size={40} color="#666" />
            <Text style={styles.placeholderText}>Add Photo</Text>
          </View>
        )}
      </TouchableOpacity>
      {error && <Text style={styles.errorText}>{error}</Text>}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginBottom: 20,
  },
  photoContainer: {
    width: 120,
    height: 120,
    borderRadius: 60,
    backgroundColor: '#f0f0f0',
    overflow: 'hidden',
    marginBottom: 8,
  },
  photo: {
    width: '100%',
    height: '100%',
  },
  placeholder: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
    borderColor: '#ddd',
    borderStyle: 'dashed',
    borderRadius: 60,
  },
  placeholderText: {
    color: '#666',
    marginTop: 4,
    fontSize: 12,
  },
  errorText: {
    color: '#ff0000',
    fontSize: 12,
    marginTop: 4,
  },
});

export default ProfilePhoto;
